// import { createSlice } from '@reduxjs/toolkit';

// const authSlice = createSlice({
//     name: 'auth',
//     initialState: {
//         user: null,
//         token: null,
//         isAuthenticated: false,
//         loading: false,
//         error: null,
//     },
//     reducers: {
//         setCredentials: (state, action) => {
//             state.user = action.payload.user;
//             state.token = action.payload.token;
//             state.isAuthenticated = true;
//             state.error = null;
//         },
//         logout: (state) => { state.user = null; state.token = null; state.isAuthenticated = false; },
//         setLoading: (state, action) => { state.loading = action.payload; },
//         setError: (state, action) => { state.error = action.payload; },
//         clearError: (state) => { state.error = null; },
//     },
// });

// export const { setCredentials, logout, setLoading, setError, clearError } = authSlice.actions;
// export default authSlice.reducer;
// src/store/slices/authSlice.js
import { createSlice } from '@reduxjs/toolkit';

// ── Read persisted auth on app load ──────────────
const token = localStorage.getItem('authToken');
const user  = (() => {
  try { return JSON.parse(localStorage.getItem('authUser')); }
  catch { return null; }
})();
// ─────────────────────────────────────────────────

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user:            user  || null,
    token:           token || null,
    isAuthenticated: !!token,   // ← true if token exists in localStorage
    loading:         false,
    error:           null,
  },
  reducers: {
    setCredentials: (state, action) => {
      state.user            = action.payload.user;
      state.token           = action.payload.token;
      state.isAuthenticated = true;
      state.error           = null;
      // ── Also persist user to localStorage ──
      localStorage.setItem('authUser', JSON.stringify(action.payload.user));
    },
    logout: (state) => {
      state.user            = null;
      state.token           = null;
      state.isAuthenticated = false;
      // ── Clear localStorage on logout ──
      localStorage.removeItem('authToken');
      localStorage.removeItem('authUser');
    },
    setLoading: (state, action) => { state.loading = action.payload; },
    setError:   (state, action) => { state.error   = action.payload; },
    clearError: (state)         => { state.error   = null; },
  },
});

export const { setCredentials, logout, setLoading, setError, clearError } = authSlice.actions;
export default authSlice.reducer;
